module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.3cf0ee27.ttf";